import { type IconProps } from '@carvana/ds-icons';
import Acura from '@carvana/ds-icons/Acura';
import AlfaRomeo from '@carvana/ds-icons/AlfaRomeo';
import Audi from '@carvana/ds-icons/Audi';
import BMW from '@carvana/ds-icons/BMW';
import Buick from '@carvana/ds-icons/Buick';
import Cadillac from '@carvana/ds-icons/Cadillac';
import Chevrolet from '@carvana/ds-icons/Chevrolet';
import Chrysler from '@carvana/ds-icons/Chrysler';
import Dodge from '@carvana/ds-icons/Dodge';
import Fiat from '@carvana/ds-icons/Fiat';
import Fisker from '@carvana/ds-icons/Fisker';
import Ford from '@carvana/ds-icons/Ford';
import Genesis from '@carvana/ds-icons/Genesis';
import GMC from '@carvana/ds-icons/GMC';
import Honda from '@carvana/ds-icons/Honda';
import Hyundai from '@carvana/ds-icons/Hyundai';
import Ineos from '@carvana/ds-icons/Ineos';
import Infiniti from '@carvana/ds-icons/Infiniti';
import Jaguar from '@carvana/ds-icons/Jaguar';
import Jeep from '@carvana/ds-icons/Jeep';
import Kia from '@carvana/ds-icons/Kia';
import LandRover from '@carvana/ds-icons/LandRover';
import Lexus from '@carvana/ds-icons/Lexus';
import Lincoln from '@carvana/ds-icons/Lincoln';
import Lucid from '@carvana/ds-icons/Lucid';
import Maserati from '@carvana/ds-icons/Maserati';
import Mazda from '@carvana/ds-icons/Mazda';
import MercedesBenz from '@carvana/ds-icons/MercedesBenz';
import Mercury from '@carvana/ds-icons/Mercury';
import Mini from '@carvana/ds-icons/Mini';
import Mitsubishi from '@carvana/ds-icons/Mitsubishi';
import Nissan from '@carvana/ds-icons/Nissan';
import Polestar from '@carvana/ds-icons/Polestar';
import Pontiac from '@carvana/ds-icons/Pontiac';
import Porsche from '@carvana/ds-icons/Porsche';
import Ram from '@carvana/ds-icons/Ram';
import Rivian from '@carvana/ds-icons/Rivian';
import Saab from '@carvana/ds-icons/Saab';
import Saturn from '@carvana/ds-icons/Saturn';
import Scion from '@carvana/ds-icons/Scion';
import Smart from '@carvana/ds-icons/Smart';
import Subaru from '@carvana/ds-icons/Subaru';
import Suzuki from '@carvana/ds-icons/Suzuki';
import Tesla from '@carvana/ds-icons/Tesla';
import Toyota from '@carvana/ds-icons/Toyota';
import Volkswagen from '@carvana/ds-icons/Volkswagen';
import Volvo from '@carvana/ds-icons/Volvo';
import { datadogRum } from '@datadog/browser-rum';
import { ComponentType } from 'react';

const VEHICLE_MAKE_ICON_MAP: {
  [make: string]: ComponentType<IconProps>;
} = {
  Acura,
  'Alfa Romeo': AlfaRomeo,
  Audi,
  BMW,
  Buick,
  Cadillac,
  Chevrolet,
  Chrysler,
  Dodge,
  FIAT: Fiat,
  Fisker,
  Ford,
  Genesis,
  GMC,
  Honda,
  Hyundai,
  Ineos,
  INFINITI: Infiniti,
  Jaguar,
  Jeep,
  Kia,
  'Land Rover': LandRover,
  Lexus,
  Lincoln,
  Lucid,
  Maserati,
  Mazda,
  'Mercedes-Benz': MercedesBenz,
  Mercury,
  MINI: Mini,
  Mitsubishi,
  Nissan,
  Polestar,
  Pontiac,
  Porsche,
  Ram,
  Rivian,
  Saab,
  Saturn,
  Scion,
  Smart,
  Subaru,
  Suzuki,
  Tesla,
  Toyota,
  Volkswagen,
  Volvo
};

type OwnProps = IconProps & {
  make?: string;
};

export default function VehicleMakeIcon({ make, ...iconProps }: OwnProps) {
  if (!make) {
    return null;
  }

  const Icon = VEHICLE_MAKE_ICON_MAP[make];

  if (!Boolean(Icon)) {
    datadogRum.addAction('Missing Icon', { make });
  }

  return Boolean(Icon) ? <Icon size={24} {...iconProps} /> : null;
}
